import { __assign, __extends, __rest } from "tslib";
import React, { PureComponent } from 'react';
import { withBemMod } from '@bem-react/core';
import debounce from 'lodash.debounce';
import { cnToolsSuggest } from '../ToolsSuggest';
/**
 * Модификатор, отвечающий за асинхронную загрузку пунктов меню
 * @param {IToolsSuggestDataproviderProps} props
 */
export var withDataprovider = withBemMod(cnToolsSuggest(), { dataprovider: '*' }, function (ToolsSuggest) { return (/** @class */ (function (_super) {
    __extends(WithDataprovider, _super);
    function WithDataprovider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleValueChange = function (text) {
            _this.setState({ text: text });
            _this.handleLoad(text);
            if (_this.props.onValueChange) {
                _this.props.onValueChange(text);
            }
        };
        _this.handleLoad = debounce(function (text) {
            _this.setState({
                loading: true,
            }, function () {
                if (!_this.props.dataprovider) {
                    return;
                }
                _this.props.dataprovider(text).then(_this.handleChoicesSuccess.bind(_this, text), _this.handleChoicesError);
            });
        }, _this.props.debounceTimeout);
        /**
         * Обработчик успешного ответа в dataprovider
         * @param {String} text
         * @param {Item[]} choices
         */
        _this.handleChoicesSuccess = function (text, choices) {
            var relevant = text === _this.state.text;
            if (relevant) {
                _this.setState({
                    choices: choices,
                    loading: false,
                });
            }
        };
        /**
         * Обработчик ошибки в dataprovider
         * @param {Object} err
         */
        _this.handleChoicesError = function (err) {
            _this.setState({
                loading: false,
            });
            console.error(err);
        };
        return _this;
    }
    WithDataprovider.prototype.render = function () {
        if (!this.props.dataprovider) {
            return React.createElement(ToolsSuggest, __assign({}, this.props));
        }
        var _a = this.props, 
        // Исключаем проброс параметров в базовый компонент
        _dataprovider = _a.dataprovider, _debounceTimeout = _a.debounceTimeout, _choices = _a.choices, _loading = _a.loading, props = __rest(_a, ["dataprovider", "debounceTimeout", "choices", "loading"]);
        var _b = this.state, choices = _b.choices, loading = _b.loading;
        return (React.createElement(ToolsSuggest, __assign({}, props, { choices: choices, loading: loading, onValueChange: this.handleValueChange })));
    };
    return WithDataprovider;
}(PureComponent))); });
